import { render } from "./VaIconMessage.vue?vue&type=template&id=27d08af9"
import script from "./VaIconMessage.vue?vue&type=script&lang=js"
export * from "./VaIconMessage.vue?vue&type=script&lang=js"

import "./VaIconMessage.vue?vue&type=style&index=0&id=27d08af9&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__